import { render, staticRenderFns } from "./Vial.vue?vue&type=template&id=0d16052a&scoped=true&"
import script from "./Vial.vue?vue&type=script&lang=js&"
export * from "./Vial.vue?vue&type=script&lang=js&"
import style0 from "./Vial.vue?vue&type=style&index=0&id=0d16052a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d16052a",
  null
  
)

export default component.exports